import { ContentSwitcher } from '@lego/connect-components-react';
import { PageWrapper } from '@/components/page-wrapper/page-wrapper';
import { useState } from 'react';
import RulesContent from './tabs/rules-tab';
import { SettingsContent } from './tabs/settings/settings-content';

enum TAB {
  SETTINGS = 'Settings',
  RULES = 'Rules',
}

export const PriceSetupCalcSettingsPage = () => {
  const [activeTab, setActiveTab] = useState<TAB>(TAB.SETTINGS);

  return (
    <PageWrapper
      headerProps={{
        title: 'Calculation settings',
        actions: (
          <div
            style={{
              display: 'flex',
              alignSelf: 'flex-end',
              width: '200px',
              backgroundColor: 'lightsteelblue',
              borderRadius: 'var(--ds-layout-radius-pill)',
            }}
          >
            <ContentSwitcher
              aria-label="Content Switcher"
              variant="emphasis"
              width="fill"
              size="small"
              onSwitch={(value) => setActiveTab(value as TAB)}
            >
              <ContentSwitcher.Segment
                selected={activeTab === TAB.SETTINGS}
                aria-controls={TAB.SETTINGS}
                text={TAB.SETTINGS}
                value={TAB.SETTINGS}
              />
              <ContentSwitcher.Segment
                selected={activeTab === TAB.RULES}
                aria-controls={TAB.RULES}
                text={TAB.RULES}
                value={TAB.RULES}
              />
            </ContentSwitcher>
          </div>
        ),
      }}
      layout="scroll"
    >
      {activeTab === TAB.RULES ? <RulesContent /> : <SettingsContent />}
    </PageWrapper>
  );
};
